import api from "../services/Api";

export function setAxiosBypassAuth(value: boolean) {
    if(value) {
        api.defaults.headers['x-bypass-auth']  = `0A0qnipTqSQyI1FsKkra2Q83qpeQiUZ1dAF82DeLhNbLkTItXbnNmCD5lsQXFbG5`;
    } else {
        api.defaults.headers['x-bypass-auth'] = undefined;
    }
}